const SnippetIcon = props => (
  <svg
    width={40}
    height={40}
    viewBox="0 0 40 40"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <circle cx={20} cy={20} r={20} fill="#D7AFFC" fillOpacity={0.2} />
    <path
      d="M17.0167 24.4833L12.0333 19.5L17.0167 14.5167L15.5 13L9 19.5L15.5 26L17.0167 24.4833ZM22.65 24.4833L27.6333 19.5L22.65 14.5167L24.1667 13L30.6667 19.5L24.1667 26L22.65 24.4833Z"
      fill="#9B51E0"
    />
  </svg>
)

export default SnippetIcon
